import React from 'react'

import {FinnHeader} from './FinnHeader'
import {HolidayPiratesHeader} from './HolidayPiratesHeader'
import {KiwiHeader} from './KiwiHeader'

export {CUSTOM_HEADER_HEIGHT as FINN_CUSTOM_HEADER_HEIGHT} from './FinnHeader/constants'
export {CUSTOM_HEADER_HEIGHT as HOLIDAY_PIRATES_CUSTOM_HEADER_HEIGHT} from './HolidayPiratesHeader/constants'
export {CUSTOM_HEADER_HEIGHT as KIWI_CUSTOM_HEADER_HEIGHT} from './KiwiHeader/constants'
export {CUSTOM_HEADER_HEIGHT_MOBILE as KIWI_CUSTOM_HEADER_HEIGHT_MOBILE} from './KiwiHeader/constants'
interface Props {
  /** The brand code to determine which header to render */
  brandCode: string
  /** Whether to float the header above the content. Default is `true` */
  isFloating?: boolean
  /** Whether to fix the header to the top of the page. Default is `true` */
  isFixed?: boolean
  /** Whether this is the home page. Default is `false` */
  isHomePage?: boolean
  /** Optional currency selector element to render in the header */
  currencySelector?: React.ReactNode
  /** Callback to open the preferences overlay (used by Kiwi mobile signed-in pill) */
  onShowPreferences?: () => void
  /** When set, appends a `vio_click_id` parameter to Kiwi header links (GHA click attribution) */
  vioClickId?: string
  /** Whether the Kiwi hotels nav item is the current section. Default is `true` */
  isHotelsActive?: boolean
}

/**
 * Renders a custom header based on the brand code.
 */
export const CustomHeader = ({
  brandCode,
  isFloating = false,
  isFixed = true,
  isHomePage = false,
  currencySelector,
  onShowPreferences,
  vioClickId,
  isHotelsActive
}: Props) => {
  if (brandCode === 'holidaypiratesde') {
    return <HolidayPiratesHeader isFloating={isFloating} isFixed={isFixed} />
  }
  if (brandCode === 'finn') {
    return <FinnHeader isHomePage={isHomePage} />
  }
  if (brandCode === 'kiwi') {
    return (
      <KiwiHeader
        currencySelector={currencySelector}
        onShowPreferences={onShowPreferences}
        vioClickId={vioClickId}
        isHotelsActive={isHotelsActive}
      />
    )
  }
  return null
}
